import React, { Component } from "react";
import {
  Pagination,
  Button,
  Form,
  FormGroup,
  Modal,
  Label,
  Row,
  Col,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Box } from "reactjs-admin-lte";
import FontAwesome from "react-fontawesome";
import Select from "react-select";
import SelectDate from "component/element/SelectDate";
import DatePicker from "component/element/DatePicker";
import PrintButtons from "component/element/PrintButtons";
import "./Stock.css";
import StockStore from "../../stores/StockStore";
import IframeModal from "../../component/element/IframeModal";
import { momentHelper } from "../report/helpers";
import Moment from "moment";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
const yTh = parseInt(Moment().format("YYYY")) + 543;
const WHOLE_YEAR = momentHelper.getMonth();
class StockProductTransactionModal extends Component {
  constructor(props) {
    super(props);

    const optionsYear = [];
    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i,
      });
    }
    let { messages } = this.props;
    const optionsMonth = [
      { value: 0, label: messages["All Year"] },
      { value: "01", label: messages["January"] },
      { value: "02", label: messages["February"] },
      { value: "03", label: messages["March"] },
      { value: "04", label: messages["April"] },
      { value: "05", label: messages["May"] },
      { value: "06", label: messages["June"] },
      { value: "07", label: messages["July"] },
      { value: "08", label: messages["August"] },
      { value: "09", label: messages["September"] },
      { value: "10", label: messages["October"] },
      { value: "11", label: messages["November"] },
      { value: "12", label: messages["December"] },
    ];

    const optionsInOut = [
      { value: "", label: messages["All Type"] },
      { value: "import", label: messages["Import"] },
      { value: "export", label: messages["Export"] },
      { value: "request_purchase", label: messages["Purchase Order Request"] },
      { value: "init", label: messages["Get Started"] },
    ];

    this.state = {
      loading: false,
      optionsYear: optionsYear,
      optionsMonth: optionsMonth,
      optionsInOut: optionsInOut,
      length: 5,
      totalPage: 1,
      activePage: 1,
      transaction_record: [],
      _transaction_record: [],
      defaultInOut: "",
      defaultMonth: 0,
      defaultYear: yTh,
      result_search: [],
      searchStatus: false,
      pageStatus: false,
      showExport: false,
      tabSelect: "info",
      product_stock_card: [],
      year: momentHelper.getYear(),
      month: WHOLE_YEAR,
      day: momentHelper.getDay(),
      yearRange: momentHelper.getYear(),
      dayRange: momentHelper.getDay(),
      monthRange: WHOLE_YEAR,
      isRange: false,
      itemnum: null,
      jobcards: [],
      po: [],
      fifo: [],
    };

    this.refTableId =
      "productTransactionTable-" + Math.ceil(Math.random() * 100);
    this.refTableProductStockCardId =
      "productStockCardTable-" + Math.ceil(Math.random() * 100);
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      this.setState({ itemnum: newProps.itemData.itemnum });
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    if (all_day) {
      if (all_day < this.state.day) {
        var defaultDay = "00";
      } else {
        var defaultDay = this.state.day;
      }
    } else {
      var defaultDay = "00";
    }
    return defaultDay;
  }

  loadStockTransactionRecord(stockType, item) {
    StockStore.loadStockTransactionRecord(stockType, item.itemnum, (result) => {
      let data = result.data;
      data.push({
        added_date: item.added_date,
        record_type: "init",
        request_by: item.added_by,
        quantity: "ไม่มีข้อมูล",
      });
      let _transaction_record = JSON.parse(JSON.stringify(data));
      this.setState({
        transaction_record: data,
        _transaction_record: _transaction_record,
        defaultInOut: "",
        defaultMonth: 0,
        defaultYear: yTh,
      });
    });
  }

  loadProductStockCard(stockType, itemnum, year, month, day) {
    StockStore.loadProductStockCard(
      stockType,
      itemnum,
      year,
      month,
      day,
      (result) => {
        this.setState({
          product_stock_card: result.data,
          isRange: false,
          dayRange: momentHelper.getDay(),
          monthRange: month,
          yearRange: year,
        });
      }
    );
  }

  loadProductStockCardRange(stockType, itemnum, start = "", end = "") {
    StockStore.loadProductStockCardRange(
      stockType,
      itemnum,
      start,
      end,
      (result) => {
        this.setState({ product_stock_card: result.data });
      }
    );
  }

  loadProductJobcardRecord(itemnum) {
    StockStore.loadProductJobcardRecord(itemnum, (result) => {
      this.setState({ jobcards: result.data });
    });
  }

  loadProductPORecord(itemnum) {
    StockStore.loadProductPORecord(itemnum, (result) => {
      this.setState({ po: result.data });
    });
  }

  loadProductCostFifoRecord(itemnum) {
    StockStore.loadProductCostFifoRecord(itemnum, (result) => {
      this.setState({ fifo: result.data });
    });
  }

  setTab(props) {
    let { location, stockType } = props;
    let path = "/stock/" + stockType;
    if (location.pathname === path + "/transaction") {
      this.setState({
        tabSelect: "transaction",
        itemnum: props.itemData.itemnum,
      });
      this.loadStockTransactionRecord(props.stockType, props.itemData);
    } else if (location.pathname === path + "/productstockcard") {
      this.setState({
        tabSelect: "productstockcard",
        itemnum: props.itemData.itemnum,
      });
      this.loadProductStockCard(props.stockType, props.itemData.itemnum);
    } else if (location.pathname === path + "/jobcard") {
      this.setState({ tabSelect: "jobcard", itemnum: props.itemData.itemnum });
      this.loadProductJobcardRecord(props.itemData.itemnum);
    } else if (location.pathname === path + "/po") {
      this.setState({ tabSelect: "po", itemnum: props.itemData.itemnum });
      this.loadProductPORecord(props.itemData.itemnum);
    } else if (location.pathname === path + "/fifo") {
      this.setState({ tabSelect: "fifo", itemnum: props.itemData.itemnum });
      this.loadProductCostFifoRecord(props.itemData.itemnum);
    } else {
      this.onTabsSelect("info");
    }
  }

  getSummary(data, field) {
    let sum = 0;
    data.forEach(function (item, index) {
      let value =
        item[field] === "" ||
        item[field] === null ||
        item[field] === undefined ||
        isNaN(item[field])
          ? 0
          : item[field];
      sum += value * 1;
    });
    return sum;
  }

  getNumberFormat(value, digit = 2) {
    if (value === "" || value === null || value === undefined || isNaN(value)) {
      return "";
    }
    let _val = parseFloat(value);
    return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  onShow() {
    this.onTabsSelect("info");
  }

  onStockProductTransactionCloseClick() {
    this.setState({
      totalPage: 1,
      activePage: 1,
      searchStatus: false,
      pageStatus: false,
      result_search: [],
    });
    this.props.onHide();
  }

  onStockProductTransactionEditClick() {
    this.props.onEdit();
  }

  onWorkClick(workNo) {
    this.props.onHide();
    if (window.show_work_doc !== undefined) window.show_work_doc(workNo);
    else alert("open " + workNo);
  }

  // searchItem(defaultYear,defaultMonth,defaultInOut,page = 1) {
  //   // let {transaction_record} = this.props
  //   let {_transaction_record} = this.state
  //   let {length,totalPage} = this.state
  //   let year = defaultYear - 543
  //   let result_search = []
  //   let result_all = []

  //   if (page === 1) {
  //     var start = 0
  //     this.setState({ activePage: page })
  //   } else {
  //     var start = (page * 5) - 5
  //   }

  //   _transaction_record.forEach(function(item,index) {
  //     if (item.added_date!==undefined) {
  //       let sub_year = item.added_date.substring(0, 4)
  //       let sub_month = item.added_date.substring(5, 7)
  //       sub_year = parseInt(sub_year)
  //       if (year===sub_year&&defaultMonth===0) {
  //         if (defaultInOut==='') {
  //           result_search.push(item)
  //         } else if (defaultInOut==='import') {
  //           if (item.record_type==='import') {
  //             result_search.push(item)
  //           }
  //         } else if (defaultInOut==='export') {
  //           if (item.record_type==='export') {
  //             result_search.push(item)
  //           }
  //         } else if (defaultInOut==='request_purchase') {
  //           if (item.record_type==='request_purchase') {
  //             result_search.push(item)
  //           }
  //         } else if (defaultInOut==='init') {
  //           if (item.record_type==='init') {
  //             result_search.push(item)
  //           }
  //         }
  //       } else if (year===sub_year&&defaultMonth!==0) {
  //         if (defaultMonth===sub_month) {
  //           if (defaultInOut==='') {
  //             if (item.record_type==='import'||item.record_type==='export') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='import') {
  //             if (item.record_type==='import') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='export') {
  //             if (item.record_type==='export') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='request_purchase') {
  //             if (item.record_type==='request_purchase') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='init') {
  //             if (item.record_type==='init') {
  //               result_search.push(item)
  //             }
  //           }
  //         }
  //       } else if (year!==sub_year) {
  //         if (year===sub_year) {
  //           if (defaultInOut==='') {
  //             result_search.push(item)
  //           } else if (defaultInOut==='import') {
  //             if (item.record_type==='import') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='export') {
  //             if (item.record_type==='export') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='request_purchase') {
  //             if (item.record_type==='request_purchase') {
  //               result_search.push(item)
  //             }
  //           } else if (defaultInOut==='init') {
  //             if (item.record_type==='init') {
  //               result_search.push(item)
  //             }
  //           }
  //         }
  //       }
  //     }
  //   })
  //   result_search.forEach(function(item,index) {
  //     if (index>=start&&index<length*page) {
  //       result_all.push(item)
  //     }
  //   })

  //   let allPage = result_search.length / length
  //   totalPage = Math.ceil(allPage)
  //   this.setState({result_search:result_all,searchStatus:true,totalPage:totalPage})
  // }

  searchItem(defaultYear, defaultMonth, defaultInOut, page = 1) {
    let { _transaction_record } = this.state;
    let year = defaultYear - 543;
    let result_search = [];
    if (defaultYear === yTh && defaultMonth === 0 && defaultInOut === "") {
      result_search = _transaction_record;
    } else {
      _transaction_record.forEach(function (item, index) {
        if (item.added_date !== undefined) {
          let sub_year = item.added_date.substring(0, 4);
          let sub_month = item.added_date.substring(5, 7);
          sub_year = sub_year * 1;
          sub_month = sub_month * 1;
          defaultMonth = defaultMonth * 1;
          if (year === sub_year && defaultMonth === 0) {
            if (defaultInOut === "") {
              result_search.push(item);
            } else if (defaultInOut === "import") {
              if (item.record_type === "import") {
                result_search.push(item);
              }
            } else if (defaultInOut === "export") {
              if (item.record_type === "export") {
                result_search.push(item);
              }
            } else if (defaultInOut === "request_purchase") {
              if (item.record_type === "request_purchase") {
                result_search.push(item);
              }
            } else if (defaultInOut === "init") {
              if (item.record_type === "init") {
                result_search.push(item);
              }
            }
          } else if (year === sub_year && defaultMonth !== 0) {
            if (defaultMonth === sub_month) {
              if (defaultInOut === "") {
                if (
                  item.record_type === "import" ||
                  item.record_type === "export"
                ) {
                  result_search.push(item);
                }
              } else if (defaultInOut === "import") {
                if (item.record_type === "import") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "export") {
                if (item.record_type === "export") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "request_purchase") {
                if (item.record_type === "request_purchase") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "init") {
                if (item.record_type === "init") {
                  result_search.push(item);
                }
              }
            }
          } else if (year !== sub_year) {
            if (year === sub_year) {
              if (defaultInOut === "") {
                result_search.push(item);
              } else if (defaultInOut === "import") {
                if (item.record_type === "import") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "export") {
                if (item.record_type === "export") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "request_purchase") {
                if (item.record_type === "request_purchase") {
                  result_search.push(item);
                }
              } else if (defaultInOut === "init") {
                if (item.record_type === "init") {
                  result_search.push(item);
                }
              }
            }
          }
        }
      });
    }
    this.setState({ transaction_record: result_search });
  }

  // handleSelect(e) {
  //   let result_search = []
  //   let {length} = this.state
  //   // let {transaction_record} = this.props
  //   let {_transaction_record} = this.state
  //   if (e === 1) {
  //     var start = 0
  //   } else {
  //     var start = (e * 5) - 5
  //   }

  //   if (!this.state.searchStatus) {
  //     _transaction_record.forEach(function(item,index) {
  //       if (index>=start&&index<length*e) {
  //         result_search.push(item)
  //       }
  //     })
  //     this.setState({activePage:e,result_search:result_search,pageStatus:true})
  //   } else {
  //     this.setState({activePage:e})
  //     this.searchItem(this.state.defaultYear,this.state.defaultMonth,this.state.defaultInOut,e)
  //   }
  // }

  handleSelect(e) {
    this.setState({ activePage: e, pageStatus: true });
  }

  onYearChange(e) {
    this.setState({ defaultYear: e.value, activePage: 1 });
    this.searchItem(e.value, this.state.defaultMonth, this.state.defaultInOut);
  }

  onMonthChange(e) {
    this.setState({ defaultMonth: e.value, activePage: 1 });
    this.searchItem(this.state.defaultYear, e.value, this.state.defaultInOut);
  }

  onRecordTypeChange(e) {
    this.setState({ defaultInOut: e.value, activePage: 1 });
    this.searchItem(this.state.defaultYear, this.state.defaultMonth, e.value);
  }

  onPrintClick(item) {
    let url = "";
    if (process.env.NODE_ENV === "development") {
      url =
        "https://demo2.bigfix.co/korat/pdf/?sr=" +
        item.recordid +
        "&file=stockrecord_doc";
    } else {
      url = "./pdf/?sr=" + item.recordid + "&file=stockrecord_doc";
    }
    this.refs.iframe.loadUrl(url);
  }

  onTabsSelect(key) {
    this.setState({ tabSelect: key });
    let { stockType } = this.props;
    let path = "stock/" + stockType + "/" + key;
    this.props.history.push({ pathname: "/" + path, search: "", state: {} });
    if (key === "transaction") {
      this.loadStockTransactionRecord(
        this.props.stockType,
        this.props.itemData
      );
    } else if (key === "productstockcard") {
      this.loadProductStockCard(
        this.props.stockType,
        this.props.itemData.itemnum,
        this.state.year,
        this.state.month,
        this.state.day
      );
    } else if (key === "jobcard") {
      this.loadProductJobcardRecord(this.props.itemData.itemnum);
    } else if (key === "po") {
      this.loadProductPORecord(this.props.itemData.itemnum);
    } else if (key === "fifo") {
      this.loadProductCostFifoRecord(this.props.itemData.itemnum);
    }
  }

  onUpdateQuantityAdminClick() {
    let { stockType, itemnum } = this.props;
    let { transaction_record } = this.state;
    let iQ = 0,
      eQ = 0,
      bQ = 0;
    transaction_record.map((item, index) => {
      if (item.record_type === "import") {
        iQ += item.quantity * 1;
      } else if (item.record_type === "export") {
        eQ += item.quantity * 1;
      } else if (item.record_type === "init") {
      }
      return item;
    });
    bQ = iQ - eQ;
    StockStore.forceUpdateQuantity(
      stockType,
      itemnum,
      bQ,
      function (result) {},
      function (error) {}
    );
  }

  renderWorkViewHead() {
    return <th className="text-center">{this.props.messages["Document"]}</th>;
  }

  renderTableExport() {
    let { messages } = this.props;
    return (
      <Modal
        bsSize="large"
        show={this.state.showExport}
        onHide={() => {
          this.setState({ showExport: false });
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{messages["File Download"]} Excel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id={this.refTableId} className="display-overflow">
            <table
              className="table table-responsive table-hover table-bordered-solid"
              style={{ height: "250px" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "120px" }}>{messages["Day"]}</th>
                  <th>{messages["Time"]}</th>
                  <th>{messages["Type"]}</th>
                  <th>{messages["Car Registration"]}</th>
                  <th style={{ width: "90px" }}>{messages["Note"]}</th>
                  <th>{messages["Requester"]}</th>
                  {this.renderType()}
                  <th className="text-center">{messages["Quantity"]}</th>
                  <th style={{ width: "90px" }} className="text-center">
                    {messages["Import Cost"]}
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderRowDataExport()}</tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle={null}
            className="bg-green"
            onClick={this.onDownloadClick.bind(this)}
          >
            <FontAwesome name="file-excel-o" />
            &nbsp;{messages["File Download"]} Excel
          </Button>
          <Button
            className="btn-default"
            onClick={() => {
              this.setState({ showExport: false });
            }}
          >
            <FontAwesome name="remove" /> {messages["Close"]}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderType() {
    let { stockType, messages } = this.props;
    if (stockType === "part") {
      return (
        <th style={{ width: "90px" }} className="text-center">
          {messages["Type"]}
        </th>
      );
    } else {
      return "";
    }
  }

  renderTable() {
    let { messages } = this.props;
    return (
      <div className="display-overflow">
        <table
          className="table table-responsive table-hover table-bordered-solid"
          style={{ height: "250px" }}
        >
          <thead>
            <tr>
              <th>{messages["Record Date"]}</th>
              <th>{messages["Type"]}</th>
              <th>{messages["Car Registration"]}</th>
              <th>{messages["Note"]}</th>
              <th>{messages["Requester"]}</th>
              {this.renderType()}
              <th className="text-center">{messages["Quantity"]}</th>
              <th className="text-center">{messages["Import Cost"]}</th>
              {this.renderWorkViewHead()}
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>{messages["Record Date"]}</th>
              <th>{messages["Type"]}</th>
              <th>{messages["Car Registration"]}</th>
              <th>{messages["Note"]}</th>
              <th>{messages["Requester"]}</th>
              {this.renderType()}
              <th className="text-center">{messages["Quantity"]}</th>
              <th className="text-center">{messages["Import Cost"]}</th>
              {this.renderWorkViewHead()}
            </tr>
          </tfoot>
          <tbody>{this.renderRowData()}</tbody>
        </table>
      </div>
    );
  }

  renderWorkView(item) {
    //console.log('item',item)
    let desc = item.description !== undefined ? item.description : "";
    let arr = desc.split(" ");
    if (arr.length === 2) {
      let wo = arr[1];
      let woarr = wo.split("/");
      if (woarr.length === 2) {
        return (
          <Button onClick={this.onWorkClick.bind(this, wo)}>
            <FontAwesome name="files-o" />
            {this.props.messages["Worksheet"]}
          </Button>
        );
      }
    }
    return "";
  }

  renderTransactionView(item) {
    return (
      <Button onClick={this.onPrintClick.bind(this, item)}>
        <FontAwesome name="print" />
        {this.props.messages["Item"]}
      </Button>
    );
  }

  // getPaginationData(transaction_record) {
  //   let {length,pageStatus} = this.state
  //   let data = []
  //   transaction_record.forEach(function(item,index) {
  //     if (index<length)
  //       data.push(item)
  //   })

  //   if (pageStatus) {
  //     return this.state.result_search
  //   } else {
  //     return data
  //   }
  // }

  getPaginationData(transaction_record) {
    let { activePage, length, pageStatus } = this.state;
    let data = [];
    if (!pageStatus) {
      transaction_record.forEach(function (item, index) {
        if (index < length) data.push(item);
      });
      return data;
    } else {
      let data = [];
      let start = activePage * 5 - 5;
      if (activePage === 1) {
        start = 0;
      }
      transaction_record.forEach(function (item, index) {
        if (index >= start && index < length * activePage) {
          data.push(item);
        }
      });
      return data;
    }
  }

  // renderRowDataExport() {
  //   let {transaction_record,stockType,messages}  = this.props

  //   if (transaction_record.length>0&&transaction_record!==undefined) {
  //     return(
  //       transaction_record.map((item, index) => {
  //         let record_type = ''
  //         if (item.record_type === "import") {
  //           record_type = messages['Import']
  //         } else if (item.record_type === "export") {
  //           record_type = messages['Export']
  //         } else if (item.record_type === "init") {
  //           record_type = messages['Get Started']
  //         } else if (item.record_type === "request_purchase") {
  //           record_type = messages['Purchase Order Request']
  //         }

  //         let date = ''
  //         let time = ''
  //         if (item.added_date!==undefined) {
  //           date = item.added_date.substring(0, 10)
  //           time = item.added_date.substring(11, 19)
  //         }
  //         return (
  //           <tr key={index} className={this.getRowStyle(item, index)} >
  //             <td>{ date }</td>
  //             <td>{ time }</td>
  //             <td>{ record_type }</td>
  //             <td>{ (item.car_registration_no!==undefined)?item.car_registration_no:'' }</td>
  //             <td>{ item.description }</td>
  //             <td>{ item.request_by }</td>
  //             {this.renderTypeData(item.part_type)}
  //             <td className='text-center'>{ this.getQuantity(item.quantity) }</td>
  //             <td className='text-center'>{ item.cost_per_unit }</td>
  //           </tr>
  //         )
  //       })
  //     )
  //   } else if(transaction_record.length===0){
  //     let colSpan = 8 // 7
  //     if (stockType==='part') {
  //       colSpan = 8
  //     }
  //     return(<tr><td colSpan={colSpan}><FontAwesome name='spinner'/>{messages['Fetching Data']}....</td></tr>)
  //   }else{
  //     let colSpan = 8 // 7
  //     if (stockType==='part') {
  //       colSpan = 8
  //     }
  //     return(<tr><td colSpan={colSpan}><FontAwesome name='face-sad'/>{messages['No Data']}....</td></tr>)
  //   }
  // }

  renderRowDataExport() {
    let { stockType } = this.props;
    let { transaction_record } = this.state;
    if (transaction_record.length > 0 && transaction_record !== undefined) {
      return transaction_record.map((item, index) => {
        let record_type = "";
        if (item.record_type == "import") {
          record_type = "นำเข้า";
        } else if (item.record_type == "export") {
          record_type = "นำออก";
        } else if (item.record_type == "init") {
          record_type = "เริ่มต้นใส่สินค้า";
        } else if (item.record_type == "request_purchase") {
          record_type = "ขออนุมัติสั่งซื้อ";
        }

        let date = "";
        let time = "";
        if (item.added_date !== undefined) {
          date = item.added_date.substring(0, 10);
          time = item.added_date.substring(11, 19);
        }
        return (
          <tr key={index} className={this.getRowStyle(item, index)}>
            <td>{date}</td>
            <td>{time}</td>
            <td>{record_type}</td>
            <td>
              {item.car_registration_no !== undefined
                ? item.car_registration_no
                : ""}
            </td>
            <td>{item.description}</td>
            <td>{item.request_by}</td>
            {this.renderTypeData(item.part_type)}
            <td className="text-center">{this.getQuantity(item.quantity)}</td>
            <td className="text-center">{item.cost_per_unit}</td>
          </tr>
        );
      });
    } else if (transaction_record.length === 0) {
      let colSpan = 8;
      if (stockType === "part") {
        colSpan = 9;
      }
      return (
        <tr>
          <td colSpan={colSpan}>
            <FontAwesome name="spinner" />
            กำลังดึงข้อมูล....
          </td>
        </tr>
      );
    } else {
      let colSpan = 8;
      if (stockType === "part") {
        colSpan = 9;
      }
      return (
        <tr>
          <td colSpan={colSpan}>
            <FontAwesome name="face-sad" />
            ไม่พบข้อมูล....
          </td>
        </tr>
      );
    }
  }

  renderTypeData(val) {
    let { stockType, messages } = this.props;
    if (stockType === "part") {
      if (val === "old") {
        val = messages["Old"];
      } else if (val === "similar") {
        val = messages["Similar"];
      } else if (val === "original") {
        val = messages["Original"];
      }
      return <td className="text-center">{val}</td>;
    } else {
      return "";
    }
  }

  getQuantity(quantity) {
    let { stockType } = this.props;
    if (stockType === "part") {
      if (!isNaN(quantity)) {
        quantity = quantity.toString();
      }
      if (quantity.search("(เก่า/พิเศษ)") !== -1) {
        return quantity.replace("(เก่า/พิเศษ)", "");
      } else if (quantity.search("(เทียบ)") !== -1) {
        return quantity.replace("(เทียบ)", "");
      } else if (quantity.search("(แท้)") !== -1) {
        return quantity.replace("(แท้)", "");
      } else {
        return quantity;
      }
    }
    return quantity;
  }

  // renderRowData() {
  //   let {result_search,searchStatus,_transaction_record} = this.state
  //   let {stockType,messages}  = this.props
  //   if (!searchStatus)
  //     result_search = this.getPaginationData(_transaction_record)

  //   if (undefined !== result_search && result_search.length) {
  //     return(
  //       result_search.map((item, index) => {
  //         let record_type = ''
  //         if (item.record_type === "import") {
  //           record_type = messages['Import']
  //         } else if (item.record_type === "export") {
  //           record_type = messages['Export']
  //         } else if (item.record_type === "init") {
  //           record_type = messages['Get Started']
  //         } else if (item.record_type === "request_purchase") {
  //           record_type = messages['Purchase Order Request']
  //         }

  //         return (
  //           <tr key={index} className={this.getRowStyle(item, index)} >
  //             <td>{ item.added_date }</td>
  //             <td>{ record_type }</td>
  //             <td>{ (item.car_registration_no!==undefined)?item.car_registration_no:'' }</td>
  //             <td>{ item.description }</td>
  //             <td>{ item.request_by }</td>
  //             {this.renderTypeData(item.part_type)}
  //             <td className='text-center'>{this.getQuantity(item.quantity)}</td>
  //             <td className='text-center'>{item.cost_per_unit}</td>
  //             <td className='text-center'>{this.renderTransactionView(item)} {this.renderWorkView(item)}</td>
  //           </tr>
  //         )
  //       })
  //     )
  //   } else if(_transaction_record.length===0){
  //     let colSpan = 8 // 7
  //     if (stockType==='part') {
  //       colSpan = 8
  //     }
  //     return(<tr><td colSpan={colSpan}><FontAwesome name='spinner'/>{messages['Fetching Data']}....</td></tr>)
  //   }else{
  //     let colSpan = 8 // 7
  //     if (stockType==='part') {
  //       colSpan = 8
  //     }
  //     return(<tr><td colSpan={colSpan}><FontAwesome name='face-sad'/>{messages['No Data']}....</td></tr>)
  //   }
  // }

  renderRowData() {
    let { messages, stockType } = this.props;
    if (
      undefined !== this.state.transaction_record &&
      this.state.transaction_record.length
    ) {
      let data = this.getPaginationData(this.state.transaction_record);
      return data.map((item, index) => {
        let record_type = "";
        if (item.record_type === "import") {
          record_type = messages["Import"];
        } else if (item.record_type === "export") {
          record_type = messages["Export"];
        } else if (item.record_type === "lock_export") {
          record_type = "ล็อกสินค้าไว้";
        } else if (item.record_type === "release_export") {
          record_type = "ตัดสต็อกสินค้า";
        } else if (item.record_type === "return_export") {
          record_type = "คืนสินค้าไว้";
        } else if (item.record_type === "init") {
          record_type = messages["Get Started"];
        }
        return (
          <tr key={index} className={this.getRowStyle(item, index)}>
            <td>{item.added_date}</td>
            <td>{record_type}</td>
            <td>
              {item.car_registration_no !== undefined
                ? item.car_registration_no
                : ""}
            </td>
            <td>{item.description}</td>
            <td>{item.request_by}</td>
            {this.renderTypeData(item.part_type)}
            <td className="text-center">{this.getQuantity(item.quantity)}</td>
            <td className="text-center">{item.cost_per_unit}</td>
            <td className="text-center">
              {this.renderTransactionView(item)} {this.renderWorkView(item)}
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan={stockType === "part" ? 9 : 8}>ไม่พบข้อมูล</td>
        </tr>
      );
    }
  }

  renderSummay() {
    let { unit, quantity, messages } = this.props;
    let iQ = 0,
      eQ = 0,
      bQ = 0;
    this.state.transaction_record.forEach((item, index) => {
      if (item.record_type === "import") {
        iQ += item.quantity * 1;
      } else if (item.record_type === "export") {
        eQ += item.quantity * 1;
      } else if (item.record_type === "init") {
      }
    });
    bQ = iQ - eQ;
    return (
      <div>
        {messages["From"]}{" "}
        <Label bsStyle={"success"}>
          {messages["Import"]} {iQ.toFixed(2)} {unit}
        </Label>
        <Label bsStyle={"primary"}>
          {messages["Export"]} {eQ.toFixed(2)} {unit}
        </Label>
        <Label bsStyle={"warning"}>
          {messages["Balance"]} {bQ.toFixed(2)} {unit}
        </Label>
        <Label bsStyle={"default"}>
          {messages["Actual Balance"]} {quantity.toFixed(2)} {unit}
        </Label>
      </div>
    );
  }

  getRowStyle(item, index) {
    if (item.record_type === "import") {
      return "green-row";
    } else if (item.record_type === "export") {
      return "blue-row";
    } else if (item.record_type === "request_purchase") {
      return "lightpink-row";
    } else {
      return "";
    }
  }

  onSerialNumberClick() {
    this.props.onShowSerialNumber(true);
  }

  onDownloadClick(e) {
    let { messages } = this.props;
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName =
      messages["Stock In-Out History Report"] +
      "-" +
      this.props.description +
      ".xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onExportOpen() {
    this.setState({ showExport: true });
  }

  renderToolBar() {
    let { messages } = this.props;
    return (
      <Form inline style={{ marginBottom: "10px" }}>
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.defaultYear}
            options={this.state.optionsYear}
            style={{ width: "150px" }}
            onChange={this.onYearChange.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.defaultMonth}
            options={this.state.optionsMonth}
            style={{ width: "180px" }}
            onChange={this.onMonthChange.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.defaultInOut}
            options={this.state.optionsInOut}
            style={{ width: "150px" }}
            onChange={this.onRecordTypeChange.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup>
          <Button
            bsStyle={null}
            className="bg-green"
            onClick={this.onExportOpen.bind(this)}
          >
            <FontAwesome name="file-excel-o" />
            &nbsp;{messages["File Download"]} Excel
          </Button>
        </FormGroup>
      </Form>
    );
  }

  renderPagination() {
    let { activePage, totalPage, length } = this.state;
    let { messages } = this.props;
    // if (!searchStatus) {
    //   let allPage = this.props.transaction_record.length / length
    //   totalPage = Math.ceil(allPage)
    // }
    let allPage = this.state.transaction_record.length / length;
    totalPage = Math.ceil(allPage);
    return (
      <div className="text-right">
        {" "}
        {/* style={{display:totalPage>1?'':'none'}} */}
        <Pagination
          style={{ marginBottom: "0", marginTop: "5px" }}
          prev={messages["Previous"]}
          next={messages["Next"]}
          first={false}
          last={false}
          ellipsis
          boundaryLinks
          items={totalPage}
          maxButtons={5}
          activePage={activePage}
          onSelect={this.handleSelect.bind(this)}
        />
      </div>
    );
  }

  renderInfoTable() {
    if (this.props.renderInfoTable !== undefined) {
      return this.props.renderInfoTable("form");
    }
  }

  renderTransactionTable() {
    return (
      <Box>
        <Box.Body>
          {this.renderToolBar()}
          {this.renderTable()}
          {this.renderSummay()}
          {this.renderPagination()}
        </Box.Body>
      </Box>
    );
  }

  renderRefBillNo(item) {
    if (item.ref_type == "purchaseorder") {
      let poNo = item.ref_bill_no;
      return (
        <div>
          {poNo}{" "}
          <Button onClick={this.onPOPrint.bind(this, poNo)}>
            <FontAwesome name="print" />
          </Button>
        </div>
      );
    } else {
      return item.ref_bill_no;
    }
  }

  renderProductStockCardRowData() {
    let { product_stock_card } = this.state;
    if (product_stock_card.length === 0) {
      return (
        <tr>
          <td colSpan={7}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return product_stock_card.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center">{index + 1}</td>
            <td className="text-center">{item.added_date}</td>
            <td className="text-center">{this.renderRefBillNo(item)}</td>
            <td className="text-center">{item.bill_type}</td>
            <td className="text-center">{item.in_quantity}</td>
            <td className="text-center">{item.out_quantity}</td>
            <td className="text-center">{item.balance_quantity}</td>
          </tr>
        );
      });
    }
  }

  renderJobcardRowData() {
    let { jobcards } = this.state;
    if (jobcards.length === 0) {
      return (
        <tr>
          <td colSpan={6}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return jobcards.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{item.work_date}</td>
          <td className="text-center">{item.released_date}</td>
          <td className="text-center">{item.car_registration_no}</td>
          <td className="text-center">{item.quantity}</td>
          <td className="text-right">
            {this.getNumberFormat(item.price_per_unit)}
          </td>
          <td className="text-right">{this.getNumberFormat(item.amount)}</td>
          <td className="text-center">{this.renderRecordId(item.recordid)}</td>
        </tr>
      ));
    }
  }

  renderPORowData() {
    let { po } = this.state;
    if (po.length === 0) {
      return (
        <tr>
          <td colSpan={7}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return po.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{item.purchase_order_date}</td>
          <td className="text-center">{item.released_date}</td>
          <td className="text-center">
            {this.renderPO(item.purchase_order_no)}
          </td>
          <td className="text-left">{item.shop_name}</td>
          <td className="text-center">{item.quantity}</td>
          <td className="text-right">
            {this.getNumberFormat(item.price_per_unit)}
          </td>
          <td className="text-right">{this.getNumberFormat(item.amount)}</td>
          <td className="text-center">{this.renderRecordId(item.recordid)}</td>
        </tr>
      ));
    }
  }

  onRecordPrint(recordid) {
    if (process.env.NODE_ENV === "development") {
      window.open(
        "https://demo2.bigfix.co/korat/pdf/?sr=" +
          recordid +
          "&file=stockrecord_doc"
      );
    } else {
      window.open("./pdf/?sr=" + recordid + "&file=stockrecord_doc", "_blank");
    }
  }

  onPOPrint(poNo) {
    if (process.env.NODE_ENV === "development") {
      window.open(
        "https://demo2.bigfix.co/korat/pdf/?po=" +
          poNo +
          "&file=purchaseorder_doc"
      );
    } else {
      window.open("./pdf/?po=" + poNo + "&file=purchaseorder_doc", "_blank");
    }
  }

  renderRecordId(recordid) {
    if (recordid * 1 > 0) {
      return (
        <Button onClick={this.onRecordPrint.bind(this, recordid)}>
          <FontAwesome name="print" />
        </Button>
      );
    } else {
      return "";
    }
  }

  renderPO(poNo) {
    if (poNo !== "") {
      return (
        <div>
          {poNo}{" "}
          <Button onClick={this.onPOPrint.bind(this, poNo)}>
            <FontAwesome name="print" />
          </Button>
        </div>
      );
    } else {
      return "";
    }
  }

  renderFifoRowData() {
    let { fifo } = this.state;
    if (fifo.length === 0) {
      return (
        <tr>
          <td colSpan={6}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return fifo.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{item.record_date}</td>
          <td className="text-center">
            {this.renderPO(item.purchase_order_no)}
          </td>
          <td className="text-center">{item.reception_quantity}</td>
          <td className="text-center">{item.release_quantity}</td>
          <td className="text-right">
            {this.getNumberFormat(item.cost_per_unit)}
          </td>
          <td className="text-center">{this.renderRecordId(item.recordid)}</td>
        </tr>
      ));
    }
  }

  renderFifoRowFooter() {
    let { fifo } = this.state;
    if (fifo.length === 0) {
      return "";
    }
    let sum = {
      reception_quantity: 0,
      release_quantity: 0,
      amount: 0,
      cost_avg_per_unit: 0,
    };
    fifo.forEach((item, index) => {
      sum.reception_quantity += item.reception_quantity * 1;
      sum.release_quantity += item.release_quantity * 1;
      sum.amount += item.reception_quantity * item.cost_per_unit;
    });
    sum.cost_avg_per_unit = sum.amount / sum.reception_quantity;
    return (
      <tr>
        <th colSpan="2"></th>
        <td className="text-center">{sum.reception_quantity}</td>
        <td className="text-center">{sum.release_quantity}</td>
        <td className="text-right">
          เฉลี่ย {this.getNumberFormat(sum.cost_avg_per_unit)}
        </td>
        <td></td>
      </tr>
    );
  }

  onProductStockCardDayChange(val) {
    let { stockType } = this.props;
    let { itemnum } = this.state;
    this.setState({
      day: val.value,
      isRange: false,
    });
    this.loadProductStockCard(
      stockType,
      itemnum,
      this.state.year,
      this.state.month,
      val.value
    );
  }

  onProductStockCardMonthChange(val) {
    let { stockType } = this.props;
    let { itemnum } = this.state;
    let date = this.state.year - 543 + "-" + val.value;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      month: val.value,
      isRange: false,
      day: _day,
    });
    this.loadProductStockCard(
      stockType,
      itemnum,
      this.state.year,
      val.value,
      _day
    );
  }

  onProductStockCardYearChange(val) {
    let { stockType } = this.props;
    let { itemnum } = this.state;
    let date = val.value - 543 + "-" + this.state.month;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      year: val.value,
      isRange: false,
      day: _day,
    });
    this.loadProductStockCard(
      stockType,
      itemnum,
      val.value,
      this.state.month,
      _day
    );
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableProductStockCardId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = "รายงานอะไหล่คงเหลือ.xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onStartDateRangeChange(time) {
    if (time !== "" && time !== undefined && time !== null) {
      let { stockType } = this.props;
      let { itemnum } = this.state;
      let _day = time.substr(0, 2);
      let _month = time.substr(3, 2);
      let _year = time.substr(6, 10);
      this.setState({
        day: _day * 1,
        month: _month,
        year: _year * 1,
        isRange: false,
      });
      this.loadProductStockCard(stockType, itemnum, _year, _month, _day);
    }
  }

  onEndDateRangeChange(time) {
    if (time !== "" && time !== undefined && time !== null) {
      let { stockType } = this.props;
      let { day, month, year, itemnum } = this.state;
      let _day = parseInt(time.substr(0, 2));
      let _month = parseInt(time.substr(3, 5));
      let _year = parseInt(time.substr(6, 10));
      this.setState({
        isRange: true,
        dayRange: _day,
        monthRange: _month,
        yearRange: _year,
      });
      year = year - 543;
      _year = _year - 543;
      let start = day + "/" + (month == "00" ? "1" : month) + "/" + year;
      let end = _day + "/" + _month + "/" + _year;
      this.loadProductStockCardRange(stockType, itemnum, start, end);
    }
  }

  onRangeChange(fromDateString, toDateString, items) {
    let { stockType } = this.props;
    let { day, month, year, dayRange, monthRange, yearRange, itemnum } =
      this.state;
    day = items.from.format("DD") * 1;
    month = items.from.format("MM");
    year = items.from.format("YYYY") * 1 + 543;
    dayRange = items.to.format("DD") * 1;
    monthRange = items.to.format("MM");
    yearRange = items.to.format("YYYY") * 1 + 543;
    this.setState({
      isRange: true,
      day: day,
      month: month,
      year: year,
      dayRange: dayRange,
      monthRange: monthRange,
      yearRange: yearRange,
    });
    const start = day + "/" + month + "/" + items.from.format("YYYY");
    const end = dayRange + "/" + monthRange + "/" + items.to.format("YYYY");
    this.loadProductStockCardRange(stockType, itemnum, start, end);
  }

  renderWCalendar() {
    return (
      <div style={{ display: "inline-flex" }}>
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.day == "00" ? momentHelper.getDay() : this.state.day) +
            "/" +
            (this.state.month == "00" ? WHOLE_YEAR : this.state.month) +
            "/" +
            this.state.year
          }
          onChange={this.onStartDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.dayRange == "00"
              ? momentHelper.getDay()
              : this.state.dayRange) +
            "/" +
            (this.state.monthRange == "00"
              ? WHOLE_YEAR
              : this.state.monthRange) +
            "/" +
            this.state.yearRange
          }
          onChange={this.onEndDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
      </div>
    );
  }

  renderProductStockCardTable() {
    return (
      <Box>
        <Box.Body>
          <Form inline style={{ marginBottom: "5px" }}>
            <FormGroup>
              <SelectDate
                wholeYear={true}
                year={this.state.year}
                month={this.state.month}
                day={this.state.day}
                onMonthChange={this.onProductStockCardMonthChange.bind(this)}
                onYearChange={this.onProductStockCardYearChange.bind(this)}
                onDayChange={this.onProductStockCardDayChange.bind(this)}
                dayWCalendar={true}
                renderWCalendar={this.renderWCalendar.bind(this)}
              />
            </FormGroup>{" "}
            <FormGroup>
              <PrintButtons
                onExportExcel={this.onExportExcel.bind(this)}
                marginLeft="0"
                width="auto"
              />
            </FormGroup>
          </Form>
          {this.renderDateRange()}
          <div className="table-responsive">
            <table
              id={this.refTableProductStockCardId}
              className="table table-responsive table-hover table-bordered-solid"
            >
              <thead>
                <tr>
                  <th className="text-center" style={{ width: "50px" }}>
                    ลำดับ
                  </th>
                  <th className="text-center" style={{ width: "130px" }}>
                    วัน-เวลา
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    เลขที่บิล
                  </th>
                  <th className="text-center" style={{ width: "90px" }}>
                    ประเภทบิล
                  </th>
                  <th className="text-center" style={{ width: "90px" }}>
                    จำนวนเข้า
                  </th>
                  <th className="text-center" style={{ width: "90px" }}>
                    จำนวนออก
                  </th>
                  <th className="text-center" style={{ width: "90px" }}>
                    คงเหลือ
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderProductStockCardRowData()}</tbody>
            </table>
          </div>
        </Box.Body>
      </Box>
    );
  }

  renderJobcardTable() {
    return (
      <Box>
        <Box.Body>
          <div className="table-responsive">
            <table className="table table-responsive table-hover table-bordered-solid">
              <thead>
                <tr>
                  <th style={{ width: "100px" }} className="text-center">
                    วันที่เข้าซ่อม
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    วันที่เบิกของ
                  </th>
                  <th style={{ width: "150px" }} className="text-center">
                    หมายเลขทะเบียน
                  </th>
                  <th style={{ width: "90px" }} className="text-center">
                    จำนวน
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    ราคา/หน่วย
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    จำนวนเงิน
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    พิมพ์
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderJobcardRowData()}</tbody>
              <tfoot>
                <tr>
                  <th colSpan={4} className="text-right">
                    ยอดรวมสุทธิ
                  </th>
                  <th className="text-right">
                    {this.getNumberFormat(
                      this.getSummary(this.state.jobcards, "amount")
                    )}
                  </th>
                  <th className="text-right"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </Box.Body>
      </Box>
    );
  }

  renderPOTable() {
    return (
      <Box>
        <Box.Body>
          <div className="table-responsive">
            <table className="table table-responsive table-hover table-bordered-solid">
              <thead>
                <tr>
                  <th style={{ width: "100px" }} className="text-center">
                    วันที่ทำใบสั่งซื้อ
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    วันที่นำเข้าคลัง
                  </th>
                  <th style={{ width: "150px" }} className="text-center">
                    เลขที่ใบสั่งซื้อ
                  </th>
                  <th style={{ width: "150px" }} className="text-center">
                    ชื่อร้านค้า
                  </th>
                  <th style={{ width: "90px" }} className="text-center">
                    จำนวน
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    ราคา/หน่วย
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    จำนวนเงิน
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    พิมพ์
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderPORowData()}</tbody>
              <tfoot>
                <tr>
                  <th colSpan={6} className="text-right">
                    ยอดรวมสุทธิ
                  </th>
                  <th className="text-right">
                    {this.getNumberFormat(
                      this.getSummary(this.state.po, "amount")
                    )}
                  </th>
                  <th className="text-right"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </Box.Body>
      </Box>
    );
  }

  renderFifoTable() {
    return (
      <Box>
        <Box.Body>
          <div className="table-responsive">
            <table className="table table-responsive table-hover table-bordered-solid">
              <thead>
                <tr>
                  <th style={{ width: "100px" }} className="text-center">
                    วันที่
                  </th>
                  <th style={{ width: "150px" }} className="text-center">
                    หมายเลขสั่งซื้อ
                  </th>
                  <th style={{ width: "90px" }} className="text-center">
                    จำนวน รับเข้า
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    จำนวน นำออก
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    ต้นทุน/หน่วย
                  </th>
                  <th style={{ width: "100px" }} className="text-center">
                    พิมพ์
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderFifoRowData()}</tbody>
              <tfoot>{this.renderFifoRowFooter()}</tfoot>
            </table>
          </div>
        </Box.Body>
      </Box>
    );
  }

  renderTabs() {
    let { stockType } = this.props;
    let rTitle = (
      <span>
        <FontAwesome name="info-circle" /> ข้อมูลทั่วไป
      </span>
    );
    let rTitle1 = (
      <span>
        <FontAwesome name="list-ol" /> ประวัตินำเข้า-ออก
      </span>
    );
    let rTitle2 = (
      <span>
        <FontAwesome name="puzzle-piece" /> อะไหล่คงเหลือ
      </span>
    );
    let rTitle3 = (
      <span>
        <FontAwesome name="wrench" /> ประวัติงานซ่อม
      </span>
    );
    let rTitle4 = (
      <span>
        <FontAwesome name="shopping-cart" /> ประวัติสั่งซื้อ
      </span>
    );
    let rTitle5 = (
      <span>
        <FontAwesome name="money" /> ต้นทุน FIFO
      </span>
    );
    return (
      <Row>
        <Col md={12}>
          <Tabs
            activeKey={this.state.tabSelect}
            animation={false}
            id="stock-transaction-tabs"
            onSelect={this.onTabsSelect.bind(this)}
          >
            <Switch>
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/info"}
                render={(props) => this.renderInfoTable()}
              />
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/transaction"}
                render={(props) => this.renderTransactionTable()}
              />
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/productstockcard"}
                render={(props) => this.renderProductStockCardTable()}
              />
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/jobcard"}
                render={(props) => this.renderJobcardTable()}
              />
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/po"}
                render={(props) => this.renderPOTable()}
              />
              <Route
                exact
                path={"/stock/" + this.props.stockType + "/fifo"}
                render={(props) => this.renderFifoTable()}
              />
              <Route render={(props) => this.renderInfoTable()} />
            </Switch>
            <Tab eventKey={"info"} title={rTitle}></Tab>
            <Tab eventKey={"transaction"} title={rTitle1}></Tab>
            {stockType !== "tool" ? (
              <Tab eventKey={"productstockcard"} title={rTitle2}></Tab>
            ) : (
              ""
            )}
            {stockType !== "tool" ? (
              <Tab eventKey={"jobcard"} title={rTitle3}></Tab>
            ) : (
              ""
            )}
            {stockType !== "tool" ? (
              <Tab eventKey={"po"} title={rTitle4}></Tab>
            ) : (
              ""
            )}
            {stockType !== "tool" && this.props.showCostPerUnitField ? (
              <Tab eventKey={"fifo"} title={rTitle5}></Tab>
            ) : (
              ""
            )}
          </Tabs>
        </Col>
      </Row>
    );
  }

  getStartDateRangeText() {
    let { day, month, year } = this.state;
    let txtMonth = momentHelper.getMonthText(month.toString());
    return day * 1 + " " + txtMonth + " " + year;
  }

  getEndDateRangeText() {
    let { dayRange, monthRange, yearRange } = this.state;
    dayRange = dayRange == 0 ? 1 : dayRange;
    let txtMonth = momentHelper.getMonthText(monthRange.toString());
    return dayRange + " " + txtMonth + " " + yearRange;
  }

  onRangeClearClick() {
    let { itemnum } = this.state;
    let { stockType } = this.props;
    this.loadProductStockCard(
      stockType,
      itemnum,
      this.state.year,
      this.state.month,
      this.state.day
    );
    this.setState({
      isRange: false,
      dayRange: momentHelper.getDay(),
      monthRange: this.state.month,
      yearRange: this.state.year,
    });
  }

  renderDateRange() {
    let { isRange } = this.state;
    if (isRange) {
      return (
        <div style={{ marginBottom: "10px", display: "flex" }}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;
          <Button
            className="btn btn-xs"
            onClick={this.onRangeClearClick.bind(this)}
          >
            <FontAwesome name="eraser" />
            &nbsp;ลบช่วงเวลา
          </Button>
        </div>
      );
    } else {
      return "";
    }
  }

  render() {
    let { messages } = this.props;

    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          onShow={this.onShow.bind(this)}
          onHide={this.onStockProductTransactionCloseClick.bind(this)}
          dialogClassName="fullwidth-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.props.description}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.renderTabs()}</Modal.Body>
          {/* <Modal.Footer>
            <Button style={{display:role==='admin'?'':'none'}} className="btn-danger" onClick={ this.onUpdateQuantityAdminClick.bind(this) }>
              <FontAwesome name='user' /> {messages['Adjust Amount']}
            </Button>
            <Button style={{display:'none'}}  className="btn-warning" onClick={ this.onSerialNumberClick.bind(this) }>
              <FontAwesome name='barcode' /> {messages['Enter Serial Number']}
            </Button>
            <Button className="btn-primary" onClick={ this.onStockProductTransactionEditClick.bind(this) }>
              <FontAwesome name='pencil' /> {messages['Edit Item Info']}
            </Button>
            <Button className="btn-default" onClick={ this.onStockProductTransactionCloseClick.bind(this) }>
              <FontAwesome name='remove' /> {messages['Close']}
            </Button>            
          </Modal.Footer>   */}
        </Modal>
        <IframeModal ref="iframe" title={messages["Print Document"]} />
        {this.renderTableExport()}
      </div>
    );
  }
}

StockProductTransactionModal.defaultProps = {
  show: false,
  showCostPerUnitField: true,
};

// export default connect(
//   (state) => ({messages: state.message.view.stock.StockProductTransactionModal}),null,null,{withRef:true},
// )(StockProductTransactionModal);

const mapStateToProps = (state) => ({
  store: state,
  messages: state.message.view.stock.StockProductTransactionModal,
});

const _Connect = connect(mapStateToProps)(StockProductTransactionModal);

export default withRouter(_Connect);



// WEBPACK FOOTER //
// ./src/view/stock/StockProductTransactionModal.js